import { normalizeProductImages } from "./imageUrl";

const VIETNAMESE_MARKERS =
  /[ăâđêôơưáàảãạấầẩẫậắằẳẵặéèẻẽẹếềểễệíìỉĩịóòỏõọốồổỗộớờởỡợúùủũụứừửữựýỳỷỹỵ]/i;

const ENGLISH_DESCRIPTION_MARKERS =
  /\b(in stock|upholstered|seater|seat|sofa bed|chenille|velvet|fabric|fibre|fiber|foam|cushion|cover|removable|reclining|headrest|steel|wood|legs|certified|production|made in|supplier|abrasion|washable|resistant|comfort|collection)\b/i;

const VIETNAMESE_WORD_MARKERS =
  /\b(mẫu|sản phẩm|chất liệu|kích thước|màu sắc|liên hệ|tư vấn|phòng khách|tuỳ chỉnh|tùy chỉnh|bảo hành|giao hàng)\b/i;

const FIXED_VIETNAMESE_DESCRIPTION = [
  "Mẫu sofa được Cưng Home tuyển chọn để phù hợp với nhiều không gian phòng khách hiện đại.",
  "Sản phẩm có thể tuỳ chỉnh kích thước, màu sắc và chất liệu theo nhu cầu thực tế.",
  "Vui lòng liên hệ Cưng Home để được tư vấn cấu hình, chất liệu và báo giá chi tiết.",
].join("\n");

function cleanText(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function removePremiumPhrase(value) {
  return String(value || "")
    .replace(/\s*\bcao cấp\b\s*/giu, " ")
    .replace(/\s+([,.;:!?])/g, "$1")
    .replace(/([,.;:!?])(?=\S)/g, "$1 ")
    .replace(/\s+/g, " ")
    .trim();
}

function cleanProductValue(value, key = "") {
  if (String(key).trim().toLowerCase() === "bảo hành") {
    return "3 năm (36 tháng)";
  }
  if (typeof value === "string") return removePremiumPhrase(value);
  if (Array.isArray(value)) return value.map((item) => cleanProductValue(item));
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([itemKey, item]) => [
        itemKey,
        cleanProductValue(item, itemKey),
      ])
    );
  }
  return value;
}

function getLocalizedProductName(name) {
  return removePremiumPhrase(cleanText(name)).replace(
    /\s+(?:\d+(?:[.,]\d+)?\s*cm|\d+\s*x\s*\d+(?:\s*cm)?)(?=\s*$)/i,
    ""
  );
}

function isLikelyEnglishDescription(description) {
  const text = cleanText(description);
  if (!text) return false;
  if (VIETNAMESE_MARKERS.test(text) || VIETNAMESE_WORD_MARKERS.test(text)) return false;
  return ENGLISH_DESCRIPTION_MARKERS.test(text) || Array.from(text).every((char) => char.charCodeAt(0) <= 127);
}

function buildVietnameseDescription() {
  return FIXED_VIETNAMESE_DESCRIPTION;
}

export function getLocalizedProductDescription(product) {
  // Clean each line separately to preserve paragraphs and bullet lists.
  const description = String(product?.description || "")
    .split(/\r\n|\r|\n/)
    .map(removePremiumPhrase)
    .join("\n")
    .trim();

  if (!description || isLikelyEnglishDescription(description)) {
    return buildVietnameseDescription(product);
  }

  return description;
}

export function localizeProduct(product) {
  if (!product) return product;

  const cleanedProduct = normalizeProductImages(cleanProductValue(product));

  return {
    ...cleanedProduct,
    name: getLocalizedProductName(cleanedProduct.name),
    description: getLocalizedProductDescription(product),
  };
}
